import { render } from "./DropdownMenuItem.vue?vue&type=template&id=a5cdf6c4"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DropdownMenuItem.vue"]])

export default __exports__